import React, { useEffect, useRef } from "react";
import ModalActions from "components/ModalActions";
import { Formik } from "formik";
import TextareaController from "components/TextareaController";
import { focusInputRefEnd, submitOnReturn } from "utils/form";

const FeatureGroupForm = ({
  featureGroup,
  setShowModal,
  updateFeatureGroup
}) => {
  const initialValues = {
    title: featureGroup.title || ""
  };
  const inputRef = useRef(null);
  useEffect(() => {
    focusInputRefEnd(inputRef);
  }, []);

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values) => {
        updateFeatureGroup(values);
      }}
    >
      {({ submitForm }) => {
        return (
          <div className="w-100 h-100 h-auto-ns center ph3 pb3">
            <div className="w-100 bb hairline-1 pb3">
              <div className="f3">{featureGroup.title}</div>
            </div>
            <div className="pv3 bb hairline-1">
              <TextareaController
                name="title"
                label="Title"
                minRows={1}
                innerRef={inputRef}
                debounce={250}
                onKeyPress={submitOnReturn({
                  submitForm
                })}
              />
            </div>
            <ModalActions
              actions={[
                {
                  cta: "Cancel",
                  onClick: () => {
                    setShowModal(false);
                  }
                },
                {
                  cta: "Update",
                  onClick: submitForm
                }
              ]}
            />
          </div>
        );
      }}
    </Formik>
  );
};

export default FeatureGroupForm;
